import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [globalData, setGlobalData] = useState([]);
  const [catData, setCatData] = useState([]);
  const [loadings, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [globalResp, catResp] = await Promise.all([
          axios.get(
            "https://cms.ctdestinationhartford.com/wp-json/wp/v2/pages/40"
          ),
          axios.get(
            "https://cms.ctdestinationhartford.com/wp-json/wp/v2/categories"
          ),
        ]);

        setGlobalData(globalResp.data);
        setCatData(catResp.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ globalData, catData, loadings  }}>
      {children}
    </DataContext.Provider>
  );
};
